import React from 'react';
import PropTypes from 'prop-types';

import { Field, reduxForm } from 'redux-form';

import * as actions from '../actions';

import NumberFormat from 'react-number-format';
import { withStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Switch from '@material-ui/core/Switch';
import Grid from '@material-ui/core/Grid';
import Collapse from '@material-ui/core/Collapse';
import InputAdornment from '@material-ui/core/InputAdornment';

import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { validate0 } from './validate';
import ButtonValidation from './button_validation';

const numberSeparator = ' ';

const styles = theme => ({
    textField: {
      width: '100%',
    },
    formControlLabel: { 
        marginLeft: '0',
          fontSize: '1rem', 
     '& label': { fontSize: '1rem' } 
    },
    grid:{
      paddingTop:'0px !important',
      paddingBottom:'0px !important'
    },
     gridTopOnly:{
      paddingTop:'0px !important',
    },
     title:{
      fontWeight: 'bold',
      marginBottom:theme.spacing.unit
    }
  });

function renderSwitch(props) {
    const { input, label, classes, meta: { touched, error }, ...custom } = props;
    return (
        <FormControlLabel
            className={classes.formControlLabel}
            control={
                <Switch
                    checked={input.value ? true : false}
                    onChange={input.onChange}
                    color="primary"
                />
            }
            label={<Typography style={{ fontWeight: 'bold', fontSize: '1rem', '& label': { fontSize: '1rem' } }}>{label}</Typography>}
            labelPlacement="start"
        />
    );
}

function renderTextField(props) {
    const { input, classes, currency, label, meta: { touched, error } } = props;

    var value = ''
    if (input && input.value) {
        if (input.value.target && input.value.target.value) {
            value = input.value.target.value;
        }
        else {
            value = input.value;
        }
        if (value !== '') {
            value = Number(value.toString().split(numberSeparator).join(""));
        }
    }
    return (
        <TextField
            {...input}
            label={label}
            className={classes.textField}
            margin="normal"
            variant="outlined"

            value={value}
            onChange={input.onChange(value)}

            InputProps={{
                endAdornment: <InputAdornment position="end">{currency}</InputAdornment>,
                inputComponent: NumberFormatCustom,
            }}
        />
    );
}

renderTextField.propTypes = {
    classes: PropTypes.object.isRequired,
};

function NumberFormatCustom(props) {
    const { inputRef, onChange, ...other } = props;
    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={values => {
                onChange({
                    target: {
                        value: values.value,
                    },
                });
            }}
            thousandSeparator={numberSeparator}
        />
    );
}
NumberFormatCustom.propTypes = {
    inputRef: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
};

class FormEstimationRealEstate extends React.Component {

    render() {
        const { handleSubmit, classes, formUse, styles, t } = this.props;

        var currency = '';
        if (formUse && formUse.values) {
            if (formUse.values.currency && formUse.values.currency.value) {
                currency = formUse.values.currency.value;
            }
            if (formUse.values.ownerRealEstate === undefined) {
                this.props.submitFormEstimationInitialize();
            }
        }

        return (
            <form onSubmit={handleSubmit}>
                <Typography variant="h5" className={classes.title}>{t("real_estate")}</Typography>
                <Grid container spacing={8}>
                    <Grid item xs={12} className={classes.grid}>
                        {<Field
                            label={t('real_estate_label')}
                            name='ownerRealEstate'
                            type="number"
                            component={renderSwitch}
                            styles={styles}
                            classes={classes}
                        />}
                    </Grid>
                    <Grid item xs={12} className={classes.grid}>
                        <Collapse
                            in={formUse.values.ownerRealEstate}
                            timeout="auto"
                            unmountOnExit
                        >
                            <Field
                                label={t('real_estate_value')}
                                name='realEstateValue'
                                component={renderTextField}
                                currency={currency}
                                classes={classes}
                            />
                            <Field
                                label={t('indebtedness_label')}
                                name='realEstateDebt'
                                component={renderTextField}
                                currency={currency}
                                classes={classes}
                            />
                        </Collapse>
                    </Grid>
                    <Grid item xs={12}>
                        <ButtonValidation
                            activeStep={this.props.activeStep}
                            handleBack={this.props.handleBack}
                            steps={this.props.steps}
                            invalid={this.props.invalid}
                        />
                    </Grid>
                </Grid>
            </form>
        );
    }
}

FormEstimationRealEstate.propTypes = {
    classes: PropTypes.object.isRequired,
};

FormEstimationRealEstate = withStyles(styles)(FormEstimationRealEstate);


FormEstimationRealEstate = reduxForm({
    form: 'formEstimation',
    destroyOnUnmount: false, // <------ preserve form data
    forceUnregisterOnUnmount: true, // <------ unregister fields on unmount
    validate: validate0
})(FormEstimationRealEstate);

function mapStateToProps(state) {
    return {
        formUse: state.form.formEstimation,
    };
}

export default connect(mapStateToProps, actions)(withTranslation()(FormEstimationRealEstate));
